/** The SEBI registers page's URL search params (kept out of the lazily loaded page). */
export type RegisterTab = "ra" | "ia" | "both";

export interface SebiRegistersSearch {
  tab?: RegisterTab;
  q?: string;
  state?: string;
  page?: number;
}

/** The URL's search params (admin/sections.tsx). */
export function parseRegistersSearch(
  s: Record<string, unknown>,
): SebiRegistersSearch {
  const page = Number(s.page);
  return {
    ...(s.tab === "ia" || s.tab === "both" ? { tab: s.tab } : {}),
    ...(typeof s.q === "string" && s.q ? { q: s.q } : {}),
    ...(typeof s.state === "string" && s.state ? { state: s.state } : {}),
    ...(Number.isInteger(page) && page > 1 ? { page } : {}),
  };
}
